export interface DeviceInfo {
    platform: 'ios' | 'android' | 'web';
    device_type: 'mobile' | 'tablet' | 'desktop';
    os: 'ios' | 'android' | 'windows' | 'macos' | 'linux' | 'unknown';
    browser: 'chrome' | 'safari' | 'firefox' | 'edge' | 'opera' | 'unknown';
}

export function getDeviceInfo(): DeviceInfo {
    const ua = navigator.userAgent;

    // Native app detection via Capacitor
    const cap = (window as any).Capacitor;
    if (cap?.isNativePlatform?.()) {
        const nativePlatform = cap.getPlatform?.() as string;
        return {
            platform: nativePlatform === 'ios' ? 'ios' : 'android',
            device_type: 'mobile',
            os: nativePlatform === 'ios' ? 'ios' : 'android',
            browser: 'unknown',
        };
    }

    // OS detection
    let os: DeviceInfo['os'] = 'unknown';
    if (/iPhone|iPad|iPod/.test(ua)) os = 'ios';
    else if (/Android/.test(ua)) os = 'android';
    else if (/Windows/.test(ua)) os = 'windows';
    else if (/Macintosh|Mac OS X/.test(ua)) os = 'macos';
    else if (/Linux/.test(ua)) os = 'linux';

    // Device type — screen width as tiebreaker when UA is ambiguous
    let device_type: DeviceInfo['device_type'] = 'desktop';
    if (/iPad/.test(ua) || (os === 'ios' && !(/iPhone|iPod/.test(ua)))) {
        device_type = 'tablet';
    } else if (/Mobi|Android|iPhone|iPod/.test(ua)) {
        device_type = 'mobile';
    } else if (window.innerWidth <= 1024 && window.innerWidth > 768) {
        device_type = 'tablet';
    }

    // Browser detection
    let browser: DeviceInfo['browser'] = 'unknown';
    if (/OPR|Opera/.test(ua)) browser = 'opera';
    else if (/Edg\//.test(ua)) browser = 'edge';
    else if (/Chrome/.test(ua) && !/Chromium/.test(ua)) browser = 'chrome';
    else if (/Firefox/.test(ua)) browser = 'firefox';
    else if (/Safari/.test(ua)) browser = 'safari';

    return { platform: 'web', device_type, os, browser };
}
